/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Data
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import { Card } from "@mui/material";
import ContactsData from "layouts/tables/data/contactsTableData";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getAllContacts } from "api";

function AllContacts() {
  const { sales, tasks } = reportsLineChartData;

  const location = useLocation();
  const { company } = location.state || {};

  const ContactsLists = () => {
    return (
      <MDBox p={3}>
        <ContactsData company={company}></ContactsData>
      </MDBox>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar title="Contacts" />
      <MDBox py={3}>
        <Card>
          <ContactsLists />
        </Card>
      </MDBox>
      <MDBox mb={2} />
      <Footer />
    </DashboardLayout>
  );
}

export default AllContacts;
